import { h, Component } from 'preact';
import Loadable from 'react-loadable';
import get from 'lodash/get';
import Cookies from 'universal-cookie';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobileRequest, capitalizeFirstLetter, pushToDataLayer, bigBrotherEvents } from '../../utils/CommonHelper.js';
import { getHomePageData, getMostPopularVehicles } from '../../redux/actions/homepage';
import { setUserDetails } from '../../redux/actions/user';
import gtmLoader from '../../utils/GTMHelper.js';
import utmHelper from '../../utils/UtmHelper.js';

const HomePageMsite = Loadable({
    loader: () => import('../../../../q-cars/src/containers/Homepage/msite/Homepage.js'),
    loading: () => <div />,
    render (loaded, props) {
        const HomepageM = loaded.default;
        return <HomepageM {...props} />;
    }
});

const HomepageDesktop = Loadable({
    loader: () => import('../../../../q-cars/src/containers/Homepage/desktop/Homepage.js'),
    loading: () => <div />,
    render (loaded, props) {
        const HomepageD = loaded.default;
        return <HomepageD {...props} />;
    }
});

class Homepage extends Component {
    
    constructor (props, state){
        super(props);
        this.utmHelper = new utmHelper();
        this.mGlobal = 71;
    }
    
    componentDidMount () {
        window.scrollTo(0, 0);
        this.setUserData();
        if (typeof dataLayer === "undefined") {
            window.dataLayer = [];
        }
        this.fetchData();
    }

    componentWillMount () {
        this.setVariables();
    }

    componentWillReceiveProps = (nextProps) => {
        window.scrollTo(0, 0);
        if (this.props.location.key !== nextProps.location.key) {
            const currSubcat = this.props.match.params.subCat;
            const currType = this.props.match.params.type;
            const nextSubCat = nextProps.match.params.subCat;
            const nextType = nextProps.match.params.type;
            this.props = nextProps;
            this.setVariables();
            if (currSubcat !== nextSubCat || currType !== nextType) {
                this.fetchData();
            }
        }
    }

    fetchData = () => {
        const { match: { params: { city, subCat } }, data } = this.props;
        switch (subCat) {
            case 'bikes-scooters':
                this.mGlobal = 72;
                break;
            case 'cars':
                this.mGlobal = 71;
                break;
            case 'commercial-vehicles':
                this.mGlobal = 139;
                break;
            default:
                this.mGlobal = 71;
                break;
        }

        if (data && city.toLowerCase() === data.cityName.toLowerCase() && this.mGlobal === data.mGlobal && this.type === data.pageType) {
        } else {
            this.props.getHomePageData(city, this.mGlobal, this.type).then(() => {
                this.generateDataForDataLayer();
                const gtm = new gtmLoader();
                gtm.GTMCall();
                isMobileRequest() ? pushToDataLayer({"event": "pwa_cnb_page_loaded"}) : pushToDataLayer({"event": "dsite_cnb_page_loaded"});
                this.sendBigBrotherEvent('CATHOME');
                const { data } = this.props;
                localStorage.setItem('carsCategoryId', data.categoryId);
                localStorage.setItem('carsMglobal', data.mGlobal);
                this.loadQDFPJS();
                this.props.getMostPopularVehicles(this.mGlobal, data.categoryId, data.isCarsStateLevelRequest, data.stateId, this.type);
            });
        }
    }

    loadQDFPJS = () => {
        const isMobile = isMobileRequest();
        window.qdfp_vp = {
            id: isMobile ? "carshp-msite" : "carshp",
            ptargeting: [
                {
                    key: "City",
                    value: this.cityName
                }, {
                    key: "Category",
                    value: "Cars & Bikes"
                }, {
                    key: "SubCat",
                    value: this.mGlobal === 72 ? 'Bikes & Scooters' : (this.mGlobal === 139 ? 'Commercial Vehicles' : 'Cars')
                }
            ]
        };
        const imported = document.createElement('script');
        const cacheBust = Math.floor(new Date().getTime()/1000);
        const bundle = isMobile ? 'index-msite' : 'index';
        imported.src = `https://teja9.kuikr.com/public/mon/qapqdfp/cars_4.0.0/cnb/${bundle}.${cacheBust}.js`;
        document.body.appendChild(imported);
    }

    setVariables = () => {
        this.cityName =  this.props.match.params.city;
        this.subCatName = this.props.match.params.subCat;
        this.type = this.props.match.params.type;
        this.product = "cars";
        this.placeholder = "Find a Car";
        if (this.subCatName === 'bikes-scooters') {
            this.type = this.subCatName.split('-')[0];
            this.product = "bikes";
            this.placeholder = "Find a Bike";
        } else if (this.subCatName === 'commercial-vehicles') {
            this.placeholder = "Search (Eg - Tata Ace)";
            this.type = "commercial-vehicles";
            this.product = "commercial vehicles";
        }
        let date = new Date();
        date = date.getFullYear();
        const productCaps = capitalizeFirstLetter(this.product);
        const cityName = this.cityName.toLowerCase() === 'all-india' ? 'India' : capitalizeFirstLetter(this.cityName);
        if (this.type === 'new-cars') {
            this.seoTitle = `New Cars in ${cityName} ${date} : Launch Price , Specification, Offers | QuikrCars`;
            this.seoDescription = `Check which new car is best in the market according to specification, launch details, price, offers according to QuikrCars`;
        } else {
            this.seoTitle = `Buy & Sell Used ${productCaps} in ${cityName} | Buy & Sell Second Hand ${productCaps} in ${cityName} | Quikr${productCaps}`;
            this.seoDescription = `Explore the widest range of used ${this.type} and second hand ${this.type} in ${cityName}. Avail our services for financing, insurance & RTO for a smooth buying experience with Quikr${productCaps}.`;
        }
    }

    setUserData = () => {
        this.loggedIn = get(this.context, 'user.loggedIn', false);
        this.name = get(this.context, 'user.name');
        this.mobiles = get(this.context, 'user.mobile');
        this.emails = get(this.context, 'user.email');
        if (this.loggedIn !== this.props.user.loggedIn) {
            const user = {
                loggedIn: this.loggedIn,
                name: this.name,
                mobile: this.mobiles,
                email: this.emails
            };
            this.props.setUserDetails(user);
        }
    }

    generateDataForDataLayer = () => {
        const cookies = new Cookies();
        const { data } = this.props;
        const utmParameters = this.utmHelper.getUtmParameters();
        const dataToPush = {
            "PAGE_TYPE": "HP",
            "Category_Name": "Cars-Bikes",
            "SubCategory_Name": capitalizeFirstLetter(this.subCatName),
            "lang": "English",
            "USER_CITY_NAME": data.cityName,
            "Category_id": "60",
            "SubCategory_id": data.mGlobal,
            "USER_CITY_ID": data.cityId,
            "referrer": document.referrer,
            "utmSource": utmParameters.utm_source,
            "utmMedium": utmParameters.utm_medium,
            "utmCampaign": utmParameters.utm_campaign,
            "deviceType": "mobile"
        };

        if (this.loggedIn){
            dataToPush.isLoggedIn = 1;
            dataToPush.name = this.name;
            dataToPush.email = this.emails;
            dataToPush.mobile = this.mobiles;
            dataToPush.userId = cookies.get("__u");
        } else {
            dataToPush.isLoggedIn = 0;
        }
        pushToDataLayer(dataToPush);
    }
    
    sendBigBrotherEvent = (event) => {
        const { data } = this.props;
        const eventData = {
            "cat_id": 60,
            "cat_name": "Cars-Bikes",
            "subcat_id": data.mGlobal,
            "subcat_name": capitalizeFirstLetter(this.subCatName),
            "city_id": data.cityId,
            "city_name": data.cityName
        };
        bigBrotherEvents(eventData, event, 'Msite');
    }
    
    render (props) {
        return (
            isMobileRequest() ?
                <HomePageMsite
                    {...props}
                    cityName={this.cityName}
                    mGlobal={this.mGlobal}
                    placeholder={this.placeholder}
                    product={this.product}
                    seoDescription={this.seoDescription}
                    seoTitle={this.seoTitle}
                    subCatName={this.subCatName}
                    type={this.type}
                />
                :
                <HomepageDesktop
                    {...props}
                    cityName={this.cityName}
                    mGlobal={this.mGlobal}
                    placeholder={this.placeholder}
                    product={this.product}
                    seoDescription={this.seoDescription}
                    seoTitle={this.seoTitle}
                    subCatName={this.subCatName}
                    type={this.type}
                />
        );
    }
}

const mapStateToProps = state => ({
    data: state.homepage.homePageData,
    user: state.user
});

const mapDispatchToProps = dispatch => ({
    getHomePageData: (cityName, mGlobal, type) => dispatch(getHomePageData(cityName, mGlobal, type)),
    setUserDetails: (data) => dispatch(setUserDetails(data)),
    getMostPopularVehicles: (mGlobal, categoryId, isCarsStateLevelRequest, stateId, type) => dispatch(getMostPopularVehicles(mGlobal, categoryId, isCarsStateLevelRequest, stateId, type))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Homepage));



// WEBPACK FOOTER //
// ../q-cars/src/containers/Homepage/index.js